import { useEffect } from 'react'
import { ColorPickerBaseProps } from './types'
import { hexToRgba, rgbaToHex } from './utils/convert'
import { SavedColors } from './savedColors'
import { useSavedColors } from '../../hooks/colorPicker/useSavedColors'
import { RgbaColor, RgbaColorPicker } from 'react-colorful'
import './styles.scss'

export const ColorPicker = (
  props: Partial<ColorPickerBaseProps<RgbaColor>>
) => {
  const { savedColors, focusColor, setFocusColor, handleSaveColor } =
    useSavedColors({ id: props.id! })

  useEffect(() => {
    if (!focusColor.color) return

    props.onChange?.(hexToRgba(focusColor.color))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [focusColor.color])

  const handlerSavedColor = () => {
    handleSaveColor(rgbaToHex(props.color!))
    setFocusColor({ id: '', color: '' })
  }

  return (
    <div className="container-main-color-picker">
      <RgbaColorPicker
        color={props.color}
        onChange={props.onChange}
        {...props}
      />

      <SavedColors
        savedcolors={savedColors[props.id!]}
        focusColor={focusColor}
        setFocusColor={setFocusColor}
        handlerSavedColor={handlerSavedColor}
      />
    </div>
  )
}
